import React, { createContext, useContext, useEffect, useState } from 'react'
import RegistrationFormSection from './RegistrationFormSection'
import useApiUrlTranslation from './useApiUrlTranslation';
import { useParams } from "react-router-dom";

import { set, useFormContext } from 'react-hook-form';
import EventContext from '../contexts/EventContext';
import FormulaireContext from '../contexts/FormulaireContext';
import FormulaireProvider from '../contexts/FormulaireProvider';
import { CounterContext, CounterProvider } from '../contexts/CounterProvider';
import RegistrationFormStatutSection from './RegistrationFormStatutsSection';
import RegistrationFormStatut from './RegistrationFormStatut';
import { RegistrationFormSubtitleSection } from './RegistrationFormStyleSection';
import HTMLReactParser from 'html-react-parser';



const Statut = ({ cycle_lang }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [eventContactTypeList, setEventContactTypeList] = useState(false);

    const getEventContactTypeList = async () => {

        return fetch(`${apiUrlTranslation}?action=getEventContactTypeList&filter= WHERE id_event_contact_type IN(234)`)
            .then(res => res.json())
            .then(res => setEventContactTypeList(res))
    }

    useEffect(() => {
        getEventContactTypeList();
    }, [i18n.resolvedLanguage])

    const statutList = [
        "Cercle des Tech'Xplorateurs : Je décideur, utilisateur finaux, expert et consultants et souhaite participer aux chassent des tendances et des solutions innovantes collaboratives et partager mon expertise avec les autres délégations lors des débriefings",
        "Cercle des Game Changers : je suis une startup ou un fournisseur des solutions innovantes à fort potentiel d'accélération internationale je souhaite participer au pitch, webcast, et showcase en lien avec mon expertise.",
        "Cercles des Investisseurs : je suis un fond, un business angels, un venture capitalist, un financeur publics/privés et je souhaite rejoindre les jurés des sessions de pitch en lien avec mes domaines d'investissements",
        "Cercle des Tech'Xportateurs : je suis décideurs, utilisateurs, experts et consultants en capacité de vendre ou de distribuer les solutions des games changer qui m'intéressent dans mon pays ou dans mon écosystème. Je souhaite rejoindre les jurés des sessions de Tech’Xport Hub afin d’évaluer avec mes homologues d’autres pays le potentiel d'extension internationale des solutions présentées",
        "Cercle des Territoires d'excellence : je suis une agence de développement économique, d'export, un tiers lieux innovation ou un accélérateur… je souhaite accélérer mes entreprises dans monde ou en attirer de nouvelles dans mon écosystème",
    ]

    return <div>

        <ul className="divide-y space-y-2">
            {eventContactTypeList && eventContactTypeList.map((eventContactType, index) => <li>
                <label className="flex space-x-3 font-normal items-start mt-2">
                    <input
                        type="checkbox"
                    />
                    <span>{eventContactType.libelle} : {eventContactType.instructions_formulaire} </span>
                </label>
            </li>)
            }
        </ul>
    </div>
}

const FamilyItem = ({ cycle_lang }) => {

    const [eventContactType, setEventContactType] = useState({});

    //const { formulaire } = useContext(FormulaireContext);

    const formulaire = {};
    const { register } = useFormContext();

    useEffect(() => {

    }, [])

    return <tr className="programme-item">
        <td>{formulaire && formulaire.id_event_contact_type_main}
            <label className="flex space-x-3 font-normal">
                <input
                    type="checkbox"
                    {...register("cycleLangIdEventContactTypeList")}
                    value={JSON.stringify({ id_cycle_lang: cycle_lang.id_cycle_lang, id_event_contact_type: 'formulaire.id_event_contact_type_main' })}
                />
                <img className="rounded" src={`${cycle_lang.logo_better_url}`} alt="" style={{ width: "20px" }} />
                <span>{cycle_lang.nom_cycle_lang}</span>
            </label>
        </td>
    </tr>
}

const DisplayCycleLangEventLigneTypeItem = ({ cycleLangEventLigne, cycleLangCategorie }) => {

    const { i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [cycleLang, setCycleLang] = useState(false);

    useEffect(() => {

        const getCycleLang = async () => {

            return fetch(`${apiUrlTranslation}?action=getCycleLang&filter= id_cycle_lang=${cycleLangEventLigne.id_cycle_lang.id_cycle_lang} AND`)
                .then(res => res.json())
                .then(res => setCycleLang(res[0]))
        }

        getCycleLang();
    }, [i18n.resolvedLanguage])

    return <>
        {cycleLang.children && cycleLang.children
            .filter(child => child.cycle_lang_type == "collectif_programme" && child.cycle_lang_categorie == cycleLangCategorie)
            .map(child => <FamilyItem cycle_lang={child} />)}
    </>
}


const DisplayCycleLangEventLigneType = ({ cycleLangEventLigneList, type, cycleLangCategorie }) => {

    return <div>

        <p className='font-bold py-3'>{type}</p>

        <table>

            {cycleLangEventLigneList && cycleLangEventLigneList
                .map(cycleLangEventLigne =>
                    <DisplayCycleLangEventLigneTypeItem
                        cycleLangCategorie={cycleLangCategorie}
                        cycleLangEventLigne={cycleLangEventLigne} />
                )}

        </table>
    </div>
}

const RegistrationFormCycleLangSectionEventLigne = ({ formulaire }) => {

    const { currentEvent } = useContext(EventContext);

    //const { activeFormulaire } = useContext(FormulaireContext);

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation()

    const [cycleLangEventLigneList, setCycleLangEventLigneList] = useState(false);

    /// create a formulaire context

    //    id_event_contact_type_main 

    const getCycleLangEventLigne = async ({ idEventLigne }) => {

        return fetch(`${apiUrlTranslation}?action=getCycleLangEventLigne&params= WHERE id_event_ligne=${idEventLigne} `)

            .then(res => res.json())

            .then(res => setCycleLangEventLigneList(res))
    }

    useEffect(() => {

        currentEvent && getCycleLangEventLigne({ idEventLigne: currentEvent.event_ligne.id_event_ligne });

        //    formulaire && setFormulaire({ formulaire });
    }, [currentEvent, formulaire, i18n.resolvedLanguage])

    if (!cycleLangEventLigneList || !formulaire) return null

    return (
        <>

            <RegistrationFormSection
                supertitle={HTMLReactParser(`<div className=" bg-dark font-bold p-3 text-white text-2xl rounded-t-2xl">
               Validation de votre contribution et prise en compte de vos objectifs
            </div>`)}
                title_={formulaire.cycle_lang_event_ligne_section_title}
                instructions={formulaire.cycle_lang_event_ligne_section_instructions}>

                {/* <FormulaireContext.Provider value={{ formulaire }}> */}


                <p p className="row pl-5  pb-3 text-2xl font-bold" > Validation de votre statut</p>

                <p className="text-gray-500 pb-4 text-sm">  {formulaire.statut_section_instructions}</p>

                < RegistrationFormStatut
                    formulaire={formulaire}
                    idStatutSelection={formulaire.id_statut_selection}
                />

                <p p className="row pl-5  pb-3 text-2xl font-bold mt-3" > Vos domaines d'intérêt, d'action ou d'investissement </p>


                <FormulaireProvider>
                    <DisplayCycleLangEventLigneType
                        cycleLangCategorie="programme_thematique"
                        type="Positionnement sur le programme thématique"
                        cycleLangEventLigneList={cycleLangEventLigneList && cycleLangEventLigneList.filter(item => item.id_cycle_lang.cycle_lang_type == "collectif_planaction")} />

                    <DisplayCycleLangEventLigneType
                        cycleLangCategorie="programme_vertical"
                        type=" Positionnement sur le programmes vertical"
                        cycleLangEventLigneList={cycleLangEventLigneList && cycleLangEventLigneList.filter(item => item.id_cycle_lang.cycle_lang_type == "collectif_planaction")} />

                </FormulaireProvider>

                {/* </FormulaireContext.Provider> */}

            </RegistrationFormSection >

            {/* <RegistrationFormSection
                title="Mode de contribution à l'événement"
                instructions="Choisissez le cercle d'intelligence collective que vous souhaitez rejoindre lors de l'événement et précisez ainsi vos ambitions"
            >
                {cycleLangEventLigneList && cycleLangEventLigneList.length > 0 && (
                    <Statut cycle_lang={cycleLangEventLigneList[0].id_cycle_lang} />
                )}

            </RegistrationFormSection > */}
        </>
    )
}

export default RegistrationFormCycleLangSectionEventLigne;